'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('build', {
      url: '/build?page',
      template: '<build></build>'
    });
}



// WEBPACK FOOTER //
// ./client/app/build/build.routes.js